var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { Box, makeStyles, Paper, TextField, Typography, } from "@material-ui/core";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { useUpdateDeviceVolume } from "frontend/src/domain/devices";
var useStyles = makeStyles({
    input: {
        width: 100,
    },
});
export var EditDeviceVolume = function (_a) {
    var id = _a.id;
    var classes = useStyles();
    var _b = __read(React.useState(null), 2), deviceVolume = _b[0], setDeviceVolume = _b[1];
    var _c = useUpdateDeviceVolume(), changeDeviceVolume = _c.mutate, isSubmitting = _c.isLoading;
    var onSubmit = function (evt) {
        evt.preventDefault();
        if (deviceVolume) {
            changeDeviceVolume({ id: id, volume: deviceVolume });
        }
    };
    var onVolumeChange = function (evt) {
        var parsed = parseInt(evt.target.value);
        var value = isNaN(parsed) ? null : parsed;
        setDeviceVolume(value);
    };
    return (React.createElement(Box, { component: Paper, p: 2 },
        React.createElement(Typography, { variant: "h6" }, "\u0413\u0440\u043E\u043C\u043A\u043E\u0441\u0442\u044C"),
        React.createElement(Typography, { variant: "caption" }, "\u041E\u0442 0 \u0434\u043E 100"),
        React.createElement(Box, { display: "flex", alignItems: "flex-end", component: "form", onSubmit: onSubmit },
            React.createElement(Box, null,
                React.createElement(TextField, { label: "Значение", type: "number", value: deviceVolume !== null && deviceVolume !== void 0 ? deviceVolume : "", onChange: onVolumeChange, className: classes.input, InputProps: {
                        inputProps: {
                            min: 0,
                            max: 100,
                        },
                    } })),
            React.createElement(Box, { ml: 3 },
                React.createElement(ButtonLoader, { disabled: deviceVolume === null, isLoading: isSubmitting, variant: "contained", color: "primary", size: "small", type: "submit" }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C")))));
};
